import React from 'react';

interface Props {
  children: React.ReactNode;
}

export default function FilterWrapper({ children }: Props) {
  return (
    <div className="apex-tasks-list__filter-wrapper mr-2 mb-3">
      {children}
    </div>
  );
}
